import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  customDarkLogo: "",
  customLightLogo: "",
  spacing: {
    margins: {
      xs: "5px",
      sm: "10px",
      md: "15px",
      lg: "25px",
      xl: "35px"
    },
    padding: {
      xs: "5px",
      sm: "10px",
      md: "15px",
      lg: "25px",
      xl: "35px"
    }
  },
  shadows: { default: "0 0 6px #363B5210" },
  colors: {
    draftOrder: "#3E4A5D",
    provisionalOrder: "#FFC06A",
    updatingOrder: "#4553CA",
    dueOrder: "#4AD991",
    errorOrder: "#FF7285",
    cancelledOrder: "#FF7285",
    white: "#ffffff",
    primaryDark: "#1f1263",
    primaryLight: "#4553CA",
    accentLight: "#D5E3FF",
    error: "#FF7285",
    errorLight: "#fff4f5",
    warn: "#FFC06A",
    success: "#4AD991",
    lightestGrey: "#EAEDF0",
    lightGrey: "#D9DCE0",
    midGrey: "#3E4A5D",
    darkGrey: "#363B52",
    ziggurat: "#B8CFDD",
    ghost: "#C8CBD1",
    icon: "#B8CFDD",
    smartLight: "#FBB03B",
    smartLightGrey: "#919191",
    smartDark: "#BA3CB5",
    smartIcon: "#DD7A75",
    black: "#000000",
    mediumBlue: "#4DA1FF"
  },
  fonts: {
    weights: {
      light: 300,
      normal: 400,
      bold: 500
    },
    colors: {
      primary: "#3E4A5D",
      accent: "#D9DCE0",
      secondary: "#8B9FAC",
      white: "#ffffff",
      error: "#FF7285"
    },
    family: {
      heading: "Roboto",
      body: "Roboto"
    },
    sizes: {
      headingScale: "1",
      bodyScale: "1",
      sub: "10px",
      p: "13px",
      h1: "28px",
      h2: "20px",
      h3: "18px",
      h4: "14px",
      h5: "12px",
      h6: "10px"
    },
    spacing: {
      normal: "0",
      big: "1px"
    }
  },
  breakpoints: {
    xxs: "+10",
    xs: "+350",
    sm: "+600",
    md: "+800",
    lg: "+1000",
    xl: "+1200",
    xxl: "+1400"
  },
  borderRadius: "4px",
  transition: {
    quickest: "all ease-in-out 0.15s",
    quicker: "all ease-in-out 0.2s",
    quick: "all ease-in-out 0.4s"
  }
};

export interface FontWeights {
  light: number;
  normal: number;
  bold: number;
}

export interface FontColors {
  primary: string;
  accent: string;
  secondary: string;
  white: string;
  error: string;
}

export interface FontSizes {
  headingScale: string;
  bodyScale: string;
  sub: string;
  p: string;
  h1: string;
  h2: string;
  h3: string;
  h4: string;
  h5: string;
  h6: string;
}

export interface FontSpacing {
  normal: string;
  big: string;
}

export interface Spacing {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
}

export interface Colors {
  draftOrder: string;
  provisionalOrder: string;
  updatingOrder: string;
  dueOrder: string;
  errorOrder: string;
  cancelledOrder: string;
  white: string;
  primaryDark: string;
  primaryLight: string;
  accentLight: string;
  error: string;
  errorLight: string;
  warn: string;
  success: string;
  lightestGrey: string;
  lightGrey: string;
  midGrey: string;
  darkGrey: string;
  ziggurat: string;
  ghost: string;
  icon: string;
  smartLight: string;
  smartLightGrey: string;
  smartDark: string;
  smartIcon: string;
  black: string;
  mediumBlue: string;
}

export interface Breakpoints {
  xxs: string;
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
}

type Overrides = {
  menu?: {
    iconColor?: string;
    textColor?: string;
    background?: string;
    footerBackground?: string;
    footerIconColor?: string;
    footerIconHoverColor?: string
  };
  contextMenu?: {
    background?: string;
    alternativeBackground?: string;
  }
};

export interface ThemeType {
  customDarkLogo: string;
  customLightLogo: string;
  spacing: {
    margins: Spacing;
    padding: Spacing;
  };
  shadows: {
    default: string;
  };
  colors: Colors;
  fonts: {
    weights: FontWeights;
    colors: FontColors;
    family: {
      heading: string;
      body: string;
    },
    sizes: FontSizes;
    spacing: FontSpacing;
  };
  breakpoints: Breakpoints;
  borderRadius: string;
  transition: {
    quickest: string;
    quicker: string;
    quick: string;
  }
  overrides?: Overrides
}
